import React, { createContext, useContext, useState } from 'react';

const VisibilityContext = createContext();

export const VisibilityProvider = ({ children }) => {
  const [valuesVisible, setValuesVisible] = useState(true);

  const toggleVisibility = () => setValuesVisible(prev => !prev);

  const mask = (value) => {
    if (valuesVisible) return value;
    return '••••';
  };

  return (
    <VisibilityContext.Provider value={{ valuesVisible, toggleVisibility, mask }}>
      {children}
    </VisibilityContext.Provider>
  );
};

export const useVisibility = () => useContext(VisibilityContext);
